import {Component, Input} from '@angular/core';

@Component({
    selector: 'zah-icon-avatar',
    templateUrl: './icon-avatar.component.html',
    styleUrls: ['./icon-avatar.component.scss'],
    standalone: false
})
export class IconAvatarComponent {

  @Input()
  icon: string;
  @Input()
  color: 'primary' | 'accent' | 'disabled' = 'primary';
}
